export default {
      id: "i-analytic-services-05-usage",
      viewBox: "0 0 159 66",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-05",
      toString: function () {
        return this.url;
      }
    }